// extracted by mini-css-extract-plugin
export default {"titleBarHeight":"80px","mobileToolbarHeight":"53px","defaultBackgroundColor":"#1a699e"};